import { render, staticRenderFns } from "./SubscriptionChip.vue?vue&type=template&id=1cdc3f40&scoped=true&"
import script from "./SubscriptionChip.vue?vue&type=script&lang=js&"
export * from "./SubscriptionChip.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionChip.vue?vue&type=style&index=0&id=1cdc3f40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc3f40",
  null
  
)

export default component.exports